import { useParams, Link, Outlet, Navigate } from 'react-router-dom';
import { useCoachActivities } from '@/data/coachActivity';
import LoadingPage from '@/components/common/LoadingPage';
import { COACH_ACTIVITY_STATUS } from '@/app/coachActivity/enums';
import NotificationDot from '@/components/common/NotificationDot';
import { Separator } from '@/components/ui/separator';

const ActivitiesTab = () => {
  const params = useParams();
  const coachActivities = useCoachActivities(params.id);

  if (coachActivities.data.length === 0) {
    return <div>No activities found</div>;
  }

  if (!params.coachActivityId) {
    return (
      <Navigate
        to={`/coach/${params.id}/activities/${coachActivities.data[0].id}`}
      />
    );
  }

  return (
    <>
      <div className="flex gap-8 mb-2">
        {coachActivities.data.map((coachActivity) => (
          <Link
            key={coachActivity.id}
            to={`/coach/${params.id}/activities/${coachActivity.id}`}
          >
            <span
              className={`text-md font-bold py-2 transition-all duration-300 ${
                coachActivity.id === params.coachActivityId
                  ? 'border-b-2 border-b-primary'
                  : 'border-b-2 border-b-transparent hover:border-b-primary/30'
              }`}
            >
              <div className="relative">
                {coachActivity.status === COACH_ACTIVITY_STATUS.SUBMITTED &&
                  coachActivity.isAgreedToTerms && (
                    <NotificationDot position="-top-6 -right-9" />
                  )}
              </div>
              {coachActivity.activity.title}
            </span>
          </Link>
        ))}
      </div>
      <Separator className="my-6" />
      <Outlet />
    </>
  );
};

const ActivitiesTabLoader = () => {
  const params = useParams();
  const coachActivities = useCoachActivities(params.id);

  if (coachActivities.isLoading && !coachActivities.data) {
    return <LoadingPage />;
  }

  return <ActivitiesTab />;
};

export default ActivitiesTabLoader;
